export default "__VITE_ASSET__CjTaFXIv__"